import { HttpEvent, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SpinnerService } from '../services/spinner.service';
import { ToastrService } from '../services/toastr.service';

import * as _ from 'lodash';
import * as http_errors from '../../assets/i18n/http_errors';
import { DateService } from '../services/date.service';

/*
 * Interceptor that handles calls to the back and answers
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
   isRefreshingToken: boolean = false;
   tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
   loadingCount: any = 0;

   constructor(private readonly toastService: ToastrService,
      private readonly spinnerService: SpinnerService,
      private readonly translateService: TranslateService) { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
      this.startLoading();

      return new Observable<HttpEvent<any>>(obs => {
         next.handle(request).subscribe(
            (event) => {
               obs.next(event);
            },
            (err: any) => {
               if (_.get(err, 'status') === 401) {
                  // this.authService.logout();
               } else if (_.get(err, 'status') === 409) {
                  console.log('error interceptor: error 409')
                  this.toastService.add({
                     severity: "warn",
                     summary: this.translateService.instant('DUPLICATED.SUMMARY'),
                     detail: this.translateService.instant('DUPLICATED.DETAIL'),
                     life: 5000
                  });
               } else if (!request.url.includes("translations") && _.get(err, 'status') !== 403) {
                  if (request.url.includes("i18n")) {
                     // Default locale if browser locale is not supported by the app
                     this.translateService.currentLang = "en"
                  } else {
                     let currentLanguage = this.translateService.currentLang
         
                     let error = http_errors.errors[currentLanguage][err.status]
                     this.toastService.add({ severity: "error", summary: `ERROR`, detail: `${error}`, life: 5000 });
                  }
               }

            // If error status is different than 401 we want to skip refresh token
            // So we check that and throw the error if it's the case
               this.stopLoading();
               obs.error(err);
            },
            () => {
               this.stopLoading();
               obs.complete();
         }
         )
   })
   }

   startLoading() {
      this.loadingCount += 1;
      this.spinnerService.loading(true);
   }

   stopLoading() {
      this.loadingCount -= 1;
      if (this.loadingCount === 0) {
         this.spinnerService.loading(false);
      }
   }
}
